<template>
    <div class="container">
        <template v-if="loader_loading">
            <br>
            <div class="text-center text-muted">
                <font-awesome-icon icon="fas fa-circle-notch" size="2x" spin />
                <p>Loading data</p>
            </div>
        </template>

        <template v-if="!loader_loading">
            <div class="text-center">
                <br>
                <br>
                <br>
                <br>
                <br>
                <h3 :class="payment_info.icon.color">
                    <font-awesome-icon :icon="payment_info.icon.class" size="4x" />
                </h3>
                <br>
                <h3 v-if="payment_info.title">{{ payment_info.title }}</h3>
                <h4 v-if="payment_info.message" class="text-muted">{{ payment_info.message }}</h4>
                <br>
                <div class="btn btn-primary" @click="paymentRedirection(payment_info.status)">
                    View Detail
                    <!-- 
                    <span v-if="payment_info.status == 'success'">View Detail</span>
                    <span v-if="payment_info.status != 'success'">Back to Home</span> 
                -->
                </div>
            </div>
        </template>
    </div>
</template>

<script>
export default {
    data() {
        return {
            payment_info: {
                icon: {}
            },
            loader_loading: false,
        };
    },
    mounted() {
        this.initMainFunction();
    },
    methods: {
        initMainFunction() {
            this.loadData();
            return true;
        },

        loadData() {
            this.loader_loading = true;
            return app.checkPaymentStatus(app.gateway_order_id).then(response_data => {
                app.gateway_order_id = "";
                if (response_data) {
                    this.loader_loading = false;

                    if (response_data.payment_model) {
                        if (response_data.payment_model.client_data_json) {
                            var data = JSON.parse(response_data.payment_model.client_data_json);
                            if (data.additional_obj && data.additional_obj.record_id) {
                                app.payment_record_id = data.additional_obj.record_id;
                            }
                        }

                        if (response_data.payment_model.status == 11) {
                            this.payment_info.status = "success";
                            this.payment_info.title = "Payment Success";
                            this.payment_info.message = "Thank you for your payment";
                            this.payment_info.icon.class = "fas fa-circle-check";
                            this.payment_info.icon.color = "text-success";
                            return true;
                        }

                        if (response_data.payment_model.status == 12) {
                            this.payment_info.status = "failed";
                            this.payment_info.title = "Payment Failed";
                            this.payment_info.message = "Please try again.";
                            this.payment_info.icon.class = "fas fa-circle-xmark";
                            this.payment_info.icon.color = "text-danger";
                            return true;
                        }

                        if (response_data.payment_model.status == 10) {
                            this.payment_info.status = "pending";
                            this.payment_info.title = "Payment Pending";
                            this.payment_info.message = "Please try again.";
                            this.payment_info.icon.class = "fas fa-circle-pause";
                            this.payment_info.icon.color = "text-primary";
                            return true;
                        }
                    }
                }

                this.payment_info.status = "error";
                this.payment_info.title = "Payment Error";
                this.payment_info.message = "Please contact customer support.";
                this.payment_info.icon.class = "fas fa-circle-exclamation";
                this.payment_info.icon.color = "text-danger";
                return false;
            });
        },

        paymentRedirection(status) {
            app.redirectAfterPayment(status);
        }
    },
};
</script>
